import { ISVGIconProps } from '@northladder/design-system';

/**
 * -----------------------------------------------------------------------------
 * Renders a FingerPrint SVG icon with customizable height, width, and className.
 * The icon uses `currentColor` for its stroke, allowing color inheritance from parent elements.
 */
export function FingerPrintSVGIcon({
  height = 24,
  width = 24,
  className,
}: ISVGIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="Group_2">
          <path
            clipRule="evenodd"
            d="M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z"
            fillRule="evenodd"
            id="Path"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M18 13V14"
            id="Path_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M12 12V18"
            id="Path_3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M6.835 8.95703C6.308 9.85003 6 10.888 6 12V14"
            id="Path_4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M17.649 10C16.825 7.671 14.611 6 12 6C10.888 6 9.85 6.308 8.957 6.835"
            id="Path_5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M15 17V12C15 10.343 13.657 9 12 9C10.343 9 9 10.343 9 12V13"
            id="Path_6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            d="M9 16V17"
            id="Path_7"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
}
